import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import queryString from 'query-string';
import _ from 'lodash';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import CreateRoleModal from '../Modals/CreateRoleModal';
import EditRoleModal from '../Modals/EditRoleModal';
import DeleteRoleModal from '../Modals/DeleteRoleModal';
import EsmsPage from '../../components/EsmsPage';
import ProgressBar from '../../components/ProgressBar';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './RolesPage.module.css';

import * as AdminActions from '../../actions/adminActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as CompanyInfoActions from '../../actions/companyInfoActions';

class RolesPage extends Component {
    state = {
        availableRoles:      [],
        deleteRoleModalOpen: false,
        createRoleModalOpen: false,
        currentRole:         {
            id:          '',
            name:        '',
            description: ''
        },
        editRoleModalOpen: false,
        showProgressBar:   false,
        model:             {
            admin: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            home: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            iothub: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            imageStorage: {
                parents: null,
                read:    {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            architect: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            reports: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            rules: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            serviceManagement: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            },
            subscription: {
                parent: null,
                read:   {
                    checked: false
                },
                full: {
                    checked: false
                }
            }
        }
    }

    componentDidMount() {
        let { currentUser, companyInfo, roles } = this.props;
        const currentRole = {...this.state.currentRole};

        if (currentUser.role.id) {
            this.hydratePermissions(currentUser.role.id);

            currentRole.id = currentUser.role.id;
            currentRole.name = currentUser.role.name;
            currentRole.description = currentUser.role.description;

            this.setState({ currentRole });

            const hasTimeApp = companyInfo.applications.find(app => app.applicationName.toLowerCase() === 'time');
            if (!hasTimeApp) {
                const availRoles = roles.filter(r => r.name.toLowerCase() !== 'timeappuser');
                this.setState({ availableRoles: availRoles });
            }
            else {
                this.setState({ availableRoles: roles});
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { companyInfo, roles } = nextProps;
        const currentRole = {...nextState.currentRole};
        const queryValues = queryString.parse(this.props.history.location.search);
        if (queryValues.company && queryValues.company !== companyInfo?.companyId) {
            let availableRoles = [];
            const hasTimeApp = companyInfo.applications.find(app => app.applicationName.toLowerCase() === 'time');
            if (!hasTimeApp) {
                availableRoles = roles.filter(r => r.name.toLowerCase() !== 'timeappuser');
                this.setState({ availableRoles: availableRoles });
            }
            else {
                availableRoles = _.cloneDeep(roles);
                this.setState({ availableRoles: availableRoles});
            }

            currentRole.id = availableRoles[0].id;
            currentRole.name = availableRoles[0].name;
            currentRole.description = availableRoles[0].description;
            this.setState({ currentRole });
        }
        return true;
    }

    // This sets the role back to Admin after updating another role. 
    // componentDidUpdate(prevProps) {
    //     const { currentUser } = this.props;
    //     const currentRole = {...this.state.currentRole};

    //     if (prevProps.currentUser !== currentUser) {
    //         if (currentUser.role) {
    //             this.hydratePermissions(currentUser.role.id);

    //             currentRole.id = currentUser.role.id;
    //             currentRole.name = currentUser.role.name;
    //             currentRole.description = currentUser.role.description;

    //             this.setState({ currentRole });
    //         }
    //     }
    // }

    componentWillUnmount() {
        if (this.state.timerId) clearTimeout(this.state.timerId);
    }

    isAdminAccount = () => {
        return this.state.currentRole.name === 'Admin';
    }

    actionFailed = message => {
        this.props.enqueueSnackbar(message, 'warning');
    }


    setDefaultPermissions = () => {
        const { allScopes } = this.props;
        const permissions = [...Permissions('default')];
        const payload = [];

        permissions.forEach(permission => {
            allScopes.forEach(currentScope => {
                if (currentScope.label === permission) {
                    payload.push({
                        checked: true,
                        id:      currentScope.id,
                        label:   currentScope.label,
                        realm:   currentScope.realm
                    });
                }
            });
        });

        return payload;
    }

    savePermissions = async () => {
        const { allScopes, companyInfo, updateAuthorizationRole } = this.props;
        const { model } = this.state;

        const roleId = this.state.currentRole.id;

        let permissions = [];
        let payload = [];
        let body = {};

        for (let item in model) {
            if (model[item].full.checked) {
                permissions = [...permissions, ...Permissions(`${item}Full`)];
            } else if (model[item].read.checked) {
                permissions = [...permissions, ...Permissions(`${item}Read`)];
            }
        }

        permissions = [...permissions, ...Permissions('default')];

        permissions.forEach(permission => {
            allScopes.forEach(currentScope => {
                if (currentScope.label === permission) {
                    payload.push({
                        checked: true,
                        id:      currentScope.id,
                        label:   currentScope.label,
                        realm:   currentScope.realm
                    });
                }
            });
        });

        body.id = this.state.currentRole.id;
        body.name = this.state.currentRole.name;
        body.description = this.state.currentRole.description;
        body.scopes = [...payload];

        await updateAuthorizationRole(roleId, companyInfo.companyId, body);
    }

    hydratePermissions = roleId => {
        const { roles } = this.props.companyInfo;

        let model = {...this.state.model};

        const targetRole = roles.find(r => r.id === roleId);
        const targetScopes = targetRole.scopes.map(scope => scope.label);

        for (let item in model) {
            const permissionSetFull = [...Permissions(`${item}Full`), ...Permissions('default')];
            const permissionSetRead = [...Permissions(`${item}Read`), ...Permissions('default')];

            // Grab those scopes common between the targetScopes and permissionSet arrays
            let intersectionFull = _.intersection(targetScopes, permissionSetFull);
            let intersectionRead = _.intersection(targetScopes, permissionSetRead);

            // If no scopes exist in Permissions collection for either full or read, early exit.
            if (!permissionSetFull.length || !permissionSetRead.length) return;

            // Clear checkboxes ahead of calculating privilege level
            model[item].full.checked = false;
            model[item].read.checked = false;

            // If every permission that exists in the permissonSet array also exists in the
            // intersection array then we know the role enjoyes the given privilege level
            // (full or read).
            if (_.xor(permissionSetFull, intersectionFull).length === 0) {
                model[item].full.checked = true;
            } else if (_.xor(permissionSetRead, intersectionRead).length === 0) {
                model[item].read.checked = true;
            }
        }

        this.setState(model);
    }

    setSaveTimer = () => {
        if (this.state.timerId) clearTimeout(this.state.timerId);
        let timerId = setTimeout(() => {this.savePermissions();}, 1000);

        this.setState({ timerId });
    }

    handleCreateRole = async role => {
        const { companyInfo, createAuthorizationRole } = this.props;

        const currentRole = {...this.state.currentRole};
        const model = {...this.state.model};

        let body = {
            name:        _.get(role, 'name', ''),
            description: _.get(role, 'description', ''),
            scopes:      [...this.setDefaultPermissions()]
        };

        let isCreated = await createAuthorizationRole(companyInfo.companyId, body);

        if (isCreated) {
            currentRole.name = _.get(role, 'name', '');
            currentRole.description = _.get(role, 'description', '');
            currentRole.id = this.props.role.id;

            for (let item in model) {
                model[item].read.checked = false;
                model[item].full.checked = false;
            }

            this.setState({ currentRole, model });

            return true;
        }

        return false;
    }

    handleUpdateRole = async role => {
        const { companyInfo, updateAuthorizationRole } = this.props;

        const currentRole = {...this.state.currentRole};

        let body = {
            name:        _.get(role, 'name', ''),
            description: _.get(role, 'description', ''),
            scopes:      [...this.setDefaultPermissions()]
        };

        let isUpdated = await updateAuthorizationRole(currentRole.id, companyInfo.companyId, body);

        if (isUpdated) {
            currentRole.name = _.get(role, 'name', '');
            currentRole.description = _.get(role, 'description', '');

            this.setState({ currentRole });

            return true;
        }

        return false;
    }

    handleRoleSelect = event => {
        const value = event.target.value;
        const currentRole = {...this.state.currentRole};
        let { roles } = this.props.companyInfo;

        let targetRole = roles.find(role => role.id === value);

        currentRole.id = value;
        currentRole.name = targetRole.name;
        currentRole.description = targetRole.description;

        this.setState({ currentRole });
        this.hydratePermissions(value);
    }

    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/admin' + history.location.search);
    }

    handleToggleCreateRoleModal = () => {
        this.setState(state => ({
            createRoleModalOpen: !state.createRoleModalOpen
        }));
    }

    handleToggleEditRoleModal = () => {
        this.setState(state => ({
            editRoleModalOpen: !state.editRoleModalOpen
        }));
    }

    handleOpenDeleteRoleModal = () => {
        this.setState(state => ({
            deleteRoleModalOpen: true
        }));
    }

    handleCloseDeleteRoleModal = (currentRole) => {
        currentRole || (currentRole = { ...this.state.currentRole });
        this.setState(state => ({
            currentRole,
            deleteRoleModalOpen: false
        }));
    }

    handleCompanyReadCheck = name => event => {
        const model = {...this.state.model};

        if (!event.target.checked && !model.company.full.checked) {
            model.company.read.checked = true;

            this.setState(model);

            this.props.enqueueSnackbar('Company Read is a required permission.', 'warning');
            return;
        } else if (event.target.checked) {
            model.company.read.checked = event.target.checked;
            model.company.full.checked = false;
        }

        this.setState(model);

        this.setSaveTimer();
    }

    handleCompanyFullCheck = name => event => {
        const model = {...this.state.model};

        if (!event.target.checked && !model.company.read.checked) {
            model.company.read.checked = true;
            model.company.full.checked = false;
        } else if (event.target.checked) {
            model.company.full.checked = event.target.checked;
            model.company.read.checked = false;
        }

        this.setState(model);

        this.prepareAdminCheckboxes(event.target.value);

        this.setSaveTimer();
    }

    handleReadCheck = name => event => {
        const model = {...this.state.model};

        model[name].read.checked = event.target.checked;
        model[name].full.checked = false;

        this.setState(model);

        this.setSaveTimer();
    };

    handleFullCheck = name => event => {
        const model = {...this.state.model};

        model[name].full.checked = event.target.checked;
        model[name].read.checked = false;

        this.setState(model);

        this.setSaveTimer();
    };

    render() {
        const { companyInfo, currentScopes, errors } = this.props;
        const { showProgressBar } = this.state;

        return (
            <React.Fragment>
                {showProgressBar && <ProgressBar />}
                <EsmsPage
                    parents={[companyInfo.companyName]}
                    handlers={[this.handlePageRoute]}
                    title="Roles"
                >
                    <div className={classes.rolePageControlPanel}>
                        <FormControl
                            className={classes.roleSelectContainer}
                        >
                            <InputLabel
                                htmlFor="role"
                                classes={{
                                    focused: classes.cssFocused
                                }}
                            >
                                Role
                            </InputLabel>
                            <Select
                                value={this.state.currentRole.id}
                                onChange={this.handleRoleSelect}
                                className={classes.roleSelect}
                                inputProps={{
                                    name: 'role'
                                }}
                                MenuProps={{
                                    className: 'rolePageRoleMenu'
                                }}
                            >
                                {this.state.availableRoles.map(role => (
                                    <MenuItem
                                        value={role.id}
                                        key={role.id}
                                        className={role.id === this.state.currentRoleId
                                            ? `${classes.basicMenuItem} ${classes.selected}` : `${classes.basicMenuItem}`}
                                    >
                                        <span>{role.name}</span>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <ActionBar>
                            <ActionBarItem
                                hidden={!isAllowed(currentScopes, Permissions('roleFull'))}
                                onClick={this.handleToggleCreateRoleModal}
                                type="add"
                            >
                                New Role
                            </ActionBarItem>
                            <ActionBarItem
                                disabled={this.isAdminAccount()}
                                onClick={this.handleToggleEditRoleModal}
                                type="edit"
                            >
                                Edit Role
                            </ActionBarItem>
                            <ActionBarItem
                                onClick={this.handleOpenDeleteRoleModal}
                                disabled={this.isAdminAccount()}
                                type="delete"
                            >
                                Delete Role
                            </ActionBarItem>
                        </ActionBar>
                    </div>
                    <div className={classes.rolePageContents}>
                        <div>
                            <div className={classes.columnHeaders}>
                                <span>Read</span>
                                <span>Full Access</span>
                            </div>
                            <div className={classes.checkboxPanel}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.formGroup}>
                                        <div className={classes.checkboxLabel}>
                                            <img
                                                src="/assets/images/rulesColorIcon.svg"
                                                alt="rule builder"
                                            />
                                            <span>
                                                {applicationTitles.ruleBuilder}
                                            </span>
                                        </div>
                                        <div className={classes.readOnlyCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['rules'].read.checked}
                                                onChange={this.handleReadCheck('rules')}
                                                disabled={this.isAdminAccount()}
                                                value={'rulesRead'}
                                                color="primary"
                                            />
                                        </div>
                                        <div className={classes.fullAccessCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['rules'].full.checked}
                                                onChange={this.handleFullCheck('rules')}
                                                disabled={this.isAdminAccount()}
                                                value={'rulesFull'}
                                                color="primary"
                                            />
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                        <div>
                            <div className={classes.checkboxPanel}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.formGroup}>
                                        <div className={classes.checkboxLabel}>
                                            <img
                                                src="/assets/images/reportingColorIcon.svg"
                                                alt="reporting"
                                            />
                                            <span>
                                                {applicationTitles.reporting}
                                            </span>
                                        </div>
                                        <div className={classes.readOnlyCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['reports'].read.checked}
                                                onChange={this.handleReadCheck('reports')}
                                                disabled={this.isAdminAccount()}
                                                value={'reportsRead'}
                                                color="primary"
                                            />
                                        </div>
                                        <div className={classes.fullAccessCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['reports'].full.checked}
                                                onChange={this.handleFullCheck('reports')}
                                                disabled={this.isAdminAccount()}
                                                value={'reportsFull'}
                                                color="primary"
                                            />
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                        <div>
                            <div className={classes.checkboxPanel}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.formGroup}>
                                        <div className={classes.checkboxLabel}>
                                            <img
                                                src="/assets/images/architectColorIcon.svg"
                                                alt="architect"
                                            />
                                            <span>
                                                {applicationTitles.architect}
                                            </span>
                                        </div>
                                        <div className={classes.readOnlyCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['architect'].read.checked}
                                                onChange={this.handleReadCheck('architect')}
                                                disabled={this.isAdminAccount()}
                                                value={'architectRead'}
                                                color="primary"
                                            />
                                        </div>
                                        <div className={classes.fullAccessCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['architect'].full.checked}
                                                onChange={this.handleFullCheck('architect')}
                                                disabled={this.isAdminAccount()}
                                                value={'architectFull'}
                                                color="primary"
                                            />
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                        <div>
                            <div className={classes.checkboxPanel}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.formGroup}>
                                        <div className={classes.checkboxLabel}>
                                            <img
                                                src="/assets/images/iotHubColorIcon.svg"
                                                alt="iot hub"
                                            />
                                            <span>
                                                {applicationTitles.iotHub}
                                            </span>
                                        </div>
                                        <div className={classes.readOnlyCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['iothub'].read.checked}
                                                onChange={this.handleReadCheck('iothub')}
                                                disabled={this.isAdminAccount()}
                                                value={'iotHubRead'}
                                                color="primary"
                                            />
                                        </div>
                                        <div className={classes.fullAccessCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['iothub'].full.checked}
                                                onChange={this.handleFullCheck('iothub')}
                                                disabled={this.isAdminAccount()}
                                                value={'iotHubFull'}
                                                color="primary"
                                            />
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                        <div>
                            <div className={classes.checkboxPanel}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.formGroup}>
                                        <div className={classes.checkboxLabel}>
                                            <img
                                                src="/assets/images/adminColorIcon.svg"
                                                alt="Admin"
                                            />
                                            <span>
                                                {applicationTitles.admin}
                                            </span>
                                        </div>
                                        <div className={classes.readOnlyCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['admin'].read.checked}
                                                onChange={this.handleReadCheck('admin')}
                                                disabled={this.isAdminAccount()}
                                                value={'adminRead'}
                                                color="primary"
                                            />
                                        </div>
                                        <div className={classes.fullAccessCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['admin'].full.checked}
                                                onChange={this.handleFullCheck('admin')}
                                                disabled={this.isAdminAccount()}
                                                value={'adminFull'}
                                                color="primary"
                                            />
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                        { process.env.serviceManagementEnabled &&
                            <div>
                                <div className={classes.checkboxPanel}>
                                    <FormControl component="fieldset">
                                        <FormGroup className={classes.formGroup}>
                                            <div className={classes.checkboxLabel}>
                                                <img
                                                    src="/assets/images/serviceManualIconColor.svg"
                                                    alt="service management"
                                                />
                                                <span>
                                                    Service Request Management
                                                </span>
                                            </div>
                                            <div className={classes.readOnlyCheckBox}>
                                                <Checkbox
                                                    checked={this.state.model['serviceManagement'].read.checked}
                                                    onChange={this.handleReadCheck('serviceManagement')}
                                                    disabled={this.isAdminAccount()}
                                                    value={'serviceManagementRead'}
                                                    color="primary"
                                                />
                                            </div>
                                            <div className={classes.fullAccessCheckBox}>
                                                <Checkbox
                                                    checked={this.state.model['serviceManagement'].full.checked}
                                                    onChange={this.handleFullCheck('serviceManagement')}
                                                    disabled={this.isAdminAccount()}
                                                    value={'serviceManagementFull'}
                                                    color="primary"
                                                />
                                            </div>
                                        </FormGroup>
                                    </FormControl>
                                </div>
                            </div>
                        }
                        <div>
                            <div className={classes.checkboxPanel}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.formGroup}>
                                        <div className={classes.checkboxLabel}>
                                            <img
                                                src="/assets/images/subscriptionsIconColor.svg"
                                                alt="Subscriptions"
                                            />
                                            <span>
                                                {applicationTitles.subscriptions}
                                            </span>
                                        </div>
                                        <div className={classes.readOnlyCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['subscription'].read.checked}
                                                onChange={this.handleReadCheck('subscription')}
                                                disabled={this.isAdminAccount()}
                                                value={'subscriptionRead'}
                                                color="primary"
                                            />
                                        </div>
                                        <div className={classes.fullAccessCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['subscription'].full.checked}
                                                onChange={this.handleFullCheck('subscription')}
                                                disabled={this.isAdminAccount()}
                                                value={'subscriptionFull'}
                                                color="primary"
                                            />
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                        <div>
                            <div className={classes.checkboxPanel}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.formGroup}>
                                        <div className={classes.checkboxLabel}>
                                            <img
                                                src="/assets/images/uploadImageIcon.svg"
                                                alt="Upload"
                                            />
                                            <span>
                                                Upload Image
                                            </span>
                                        </div>
                                        <div className={classes.uploadImageCheckBox}>
                                            <Checkbox
                                                checked={this.state.model['imageStorage'].full.checked}
                                                onChange={this.handleFullCheck('imageStorage')}
                                                disabled={this.isAdminAccount()}
                                                value={'imageStorageFull'}
                                                color="primary"
                                            />
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </EsmsPage>
                <CreateRoleModal
                    open={this.state.createRoleModalOpen}
                    close={this.handleToggleCreateRoleModal}
                    create={this.handleCreateRole}
                    fail={this.actionFailed}
                    title="Create Role"
                />
                <EditRoleModal
                    open={this.state.editRoleModalOpen}
                    close={this.handleToggleEditRoleModal}
                    update={this.handleUpdateRole}
                    currentRole={this.state.currentRole}
                    title={`Edit Role: ${this.state.currentRole.name}`}
                />
                <DeleteRoleModal
                    open={this.state.deleteRoleModalOpen}
                    close={(currentRole) => this.handleCloseDeleteRoleModal(currentRole)}
                    currentRole={this.state.currentRole}
                    errors={errors}
                    message={`Are you sure you want to delete ${this.state.currentRole.name}?`}
                    title={`Confirm Delete: ${this.state.currentRole.name}`}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        allScopes:     state.core.allScopes,
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        currentUser:   state.currentUser,
        errors:        state.messages.errors,
        roles:         state.companyInfo.roles,
        role:          state.companyInfo.role
    };
};

const mapDispatchToProps = {
    ...AdminActions,
    ...ApplicationMessageActions,
    ...CompanyInfoActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RolesPage));
